module.exports = __webpack_public_path__ + "static/Anirudh.b39a2a02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Anirudh.jpg
// module id = 1289
// module chunks = 137408898365125